import { render, staticRenderFns } from "./MatchBets.vue?vue&type=template&id=2304c5dc&scoped=true"
import script from "./MatchBets.vue?vue&type=script&lang=js"
export * from "./MatchBets.vue?vue&type=script&lang=js"
import style0 from "./MatchBets.vue?vue&type=style&index=0&id=2304c5dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2304c5dc",
  null
  
)

export default component.exports